import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBotRefDetails,
  getBotRefDetails,
  updateBotRefUrl,
} from "../redux/slices/clientSlice";
import { message } from "antd";

const EditUrlModal = ({ show, botRef, onHide, oldUrl = "", onSave }) => {
  const [newUrl, setNewUrl] = useState("");

  const {
    botRefDetails,
    botRefDetailsLoading,
    botRefDetailsError,
    botRefUpdateLoading,
    botRefUpdateSuccess,
    botRefUpdateError,
  } = useSelector((state) => state.client);

  const dispatch = useDispatch();

  // Fetch botRef details when modal opens
  useEffect(() => {
    if (show && botRef) {
      setNewUrl("");
      dispatch(getBotRefDetails(botRef));
    } else {
      dispatch(clearBotRefDetails());
    }
  }, [show, botRef, dispatch]);

  // useEffect(() => {
  //   if (show) setNewUrl("");
  // }, [show]);

  const handleSave = async () => {
    if (!newUrl.trim()) {
      message.warning("Please enter a new URL");
      return;
    }

    try {
      const result = await dispatch(
        updateBotRefUrl({ botRef, newUrl: newUrl.trim() })
      ).unwrap();

      if (result?.success) {
        message.success("URL updated successfully");
        onHide();
      } else {
        message.error(result?.message || "Failed to update URL");
      }
    } catch (error) {
      message.error(error || "Something went wrong while updating URL");
    }
  };

  const currentUrl = botRefDetails?.newUrl || oldUrl;
  const isRedirected = botRefDetails?.isRedirected;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit URL</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Error State */}
        {!botRefDetailsLoading && botRefDetailsError && (
          <Alert variant="danger" className="text-center">
            {botRefDetailsError}
          </Alert>
        )}

        {botRefDetailsLoading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
            <p className="mt-3 text-muted">Loading details...</p>
          </div>
        ) : (
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Active URL</Form.Label>
              <Form.Control type="text" value={currentUrl} disabled />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>New URL</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter new URL"
                value={newUrl}
                onChange={(e) => setNewUrl(e.target.value)}
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={botRefUpdateLoading}
        >
          {botRefUpdateLoading ? "Updating..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditUrlModal;
